export default __webpack_public_path__ + "static/media/tiktokLogo.3e9d1b5c.webp";